var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentStep === 1)?_c('sign-up-form',{attrs:{"email":_vm.email},on:{"submit":_vm.sendVerificationCode}}):_c('verify-email-form',{attrs:{"loading":_vm.signingUp},on:{"submit":_vm.signup,"resend":_vm.resendCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }